<template>
  <div>
      <el-dialog :title="title" :visible="duizhangMark" :close-on-click-modal="false" width="35%" center @close="closeDialog"
      >
        <div class="addressBox" >
          <div class="textStyle">
            <span>共</span>
            <span class="textColor">{{duiZhangData.wayNumber}}</span>
            <span v-if="YSFlag=='1'">个运单，应收合计</span>
            <span v-if="YSFlag=='2'">个运单，应付合计</span>
            <span class="textColor">{{duiZhangData.totalAmount}}</span>
            <span>元</span>
          </div>
          <div class="textStyle">
            <span style="color:red;">请确认运单各项费用对账完成</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="saveFn">对账完成，创建账单</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
<script>
import { addSettlementBillForYs,addSettlementBillForYf } from '@/api/newTMS'
export default {
  name: 'duizhangMark',
  props: {
    duiZhangData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    duizhangMark: {
      type: Boolean,
      default: false
    },
    YSFlag: {
      type: Number,
      default: false
    },
  },
  data () {
    return {
      title: '对账'
    }
  },
  mounted: function () {
    console.log(this.duiZhangData,'duiZhangData')
    console.log(this.YSFlag,'YSFlag')
  },
  methods: {
    saveFn(){
      if(this.YSFlag == 1){
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addSettlementBillForYs(this.duiZhangData).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.$emit('refresh')
          this.$emit('update:duizhangMark', false)
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }else{
        addSettlementBillForYf(this.duiZhangData).then(res => {
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.$emit('refresh')
          this.$emit('update:duizhangMark', false)
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
      }
    },
    closeDialog () {
      this.$emit('update:duizhangMark', false)
    }
  },
}
</script>
<style scoped lang='less'>
.textStyle{
  text-align:center;
  margin-top:30px;
  font-size:18px;
}
.textColor{
  color:red;
  margin:0 10px;
  font-size:20px;
}
</style>